import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';

import { colors } from '../../styles';

const styles = css`
  width: 100%;
  height: 100vh;
  min-height: 600px;
  z-index: 1;
  padding: 115px 0 0;
  background-color: ${colors.color3};
  @media(min-width: 992px) {
    padding: 185px 0 0;
  }
  .HeaderLinks_menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%;
    margin: 0 auto;
    max-width: 350px;
    @media(min-width: 992px) {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      max-width: none;
      padding: 50px 40px;
      align-items: flex-start;
    }
    @media(min-width: 1450px) {
      padding: 50px 100px;
      justify-content: center;
    }
  }
  .HeaderLinks_menuItem {
    width: 100%;
    margin: 0 0 15px;
    padding: 15px 0 0;
    position: relative;
    @media(min-width: 992px) {
      width: max-content;
      margin: 0 50px 15px 0;
    }
    @media(min-width: 0\0) {
      width: auto !important;
    }
    & + li {
      border-top: 1px solid #191919;
      @media(min-width: 992px) {
        border: 0;
      }
    }
    &::after {
      content: '';
      position: absolute;
      top: 20px;
      right: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 9px solid #FFFFFF;
      @media(min-width: 992px) {
        content: none;
      }
    }
  }
  .HeaderLinks_menuItemAlt {
    &::after {
      border-top: 9px solid transparent;
      border-bottom: 9px solid #FFFFFF;
      top: 10px;
    }
  }
  .HeaderLinks_menuHeading {
    font-weight: 700;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    cursor: pointer;
    width: 100%;
    display: flex;
    @media(min-width: 992px) {
      font-weight: 500;
      font-size: 17px;
      letter-spacing: 2.83px;
      text-transform: uppercase;
    }
    &:focus {
      outline: none;
    }
  }
  .HeaderLinks_subMenu {
    display: none;
    @media(min-width: 992px) {
      display: block;
    }
  }
  .HeaderLinks_subMenu-active {
    display: block;
  }
  .HeaderLinks_subMenuItem, a {
    font-weight: 700;
    font-size: 13px;
    color: ${colors.color1};
    letter-spacing: 0;
    line-height: 34px;
    transition: all .3s ease-out;
    @media(min-width: 992px) {
      line-height: 37px;
      font-weight: 500;
      font-size: 15px;
      letter-spacing: 1px;
    }
    &.active, &:hover {
      color: #a0c4d5;
    }
  }

`;

function HeaderLinks({ activateMenu, isActiveMenu }) {
  return (
    <div className={styles}>
      <ul className="HeaderLinks_menu list-unstyled">
        <li className={`HeaderLinks_menuItem ${isActiveMenu('fyh') ? 'HeaderLinks_menuItemAlt' : ''}`}>
          <span tabIndex={0} role="button" className="HeaderLinks_menuHeading" onClick={activateMenu('fyh')}>Modern Homes</span>
          <ul className={`${isActiveMenu('fyh') ? 'HeaderLinks_subMenu-active' : ''} HeaderLinks_subMenu list-unstyled mt-2`}>
            {/* <li className="HeaderLinks_subMenuItem">
            <Link name="communities">Where To Build</Link></li> */}
            <li className="HeaderLinks_subMenuItem"><Link name="homes">Available Homes</Link></li>
            {/* <li className="HeaderLinks_subMenuItem">
            <Link name="plans">Home Designs</Link></li> */}
          </ul>
        </li>
        <li className={`HeaderLinks_menuItem ${isActiveMenu('gallery') ? 'HeaderLinks_menuItemAlt' : ''}`}>
          <span tabIndex={0} role="button" className="HeaderLinks_menuHeading" onClick={activateMenu('gallery')}>Gallery</span>
          <ul className={`${isActiveMenu('gallery') ? 'HeaderLinks_subMenu-active' : ''} HeaderLinks_subMenu list-unstyled mt-2`}>
            <li className="HeaderLinks_subMenuItem"><Link name="image-gallery">Image Gallery</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="media-and-press">Media & Press</Link></li>
          </ul>
        </li>
        <li className={`HeaderLinks_menuItem ${isActiveMenu('about') ? 'HeaderLinks_menuItemAlt' : ''}`}>
          <span tabIndex={0} role="button" className="HeaderLinks_menuHeading" onClick={activateMenu('about')}>About Us</span>
          <ul className={`${isActiveMenu('about') ? 'HeaderLinks_subMenu-active' : ''} HeaderLinks_subMenu list-unstyled mt-2`}>
            <li className="HeaderLinks_subMenuItem"><Link name="about-us">About Arjen</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="our-buying-process">Our Buying Process</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="our-construction-process">Our Construction Process</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="luxury-features">Luxury Features</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="testimonials">Testimonials</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="blog">Arjen Homes News</Link></li>
          </ul>
        </li>
        <li className={`HeaderLinks_menuItem ${isActiveMenu('contact') ? 'HeaderLinks_menuItemAlt' : ''}`}>
          <span tabIndex={0} role="button" className="HeaderLinks_menuHeading" onClick={activateMenu('contact')}>Contact</span>
          <ul className={`${isActiveMenu('contact') ? 'HeaderLinks_subMenu-active' : ''} HeaderLinks_subMenu list-unstyled mt-2`}>
            <li className="HeaderLinks_subMenuItem"><Link name="contact-us">Contact Us</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="warranty-information-request">Warranty Information & Request</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="realtor-contact">Realtor Contact</Link></li>
            <li className="HeaderLinks_subMenuItem"><Link name="vendor-registration">Vendor Registration</Link></li>

          </ul>
        </li>
      </ul>
    </div>
  );
}

HeaderLinks.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
};

export default menuToggler(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/PageWrapper/HeaderLinks.js